import axios from 'axios';

export function getCampaign({ commit }, params) {
  axios.get(`qr/${params.campaign}/${params.customer}`).then((response) => {
    if (response.data.status) {
      commit('SET_ERROR', response.data.status);
    } else {
      commit('SET_CAMPAIGN', response.data);
      commit('SET_CODES', params);
    }
  }).catch(() => {
    commit('SET_ERROR', 'notfound');
  });
}

export function updateOrder({ commit }, order) {
  commit('UPDATE_ORDER', order);
}

export function selectOffer({ commit }, offer) {
  commit('REMOVE_OFFER', offer); // Remove any existing offers with this ID
  offer.quantity = offer.quantity || offer.quantity_default; // eslint-disable-line
  commit('SELECT_OFFER', offer);
}

export function removeOffer({ commit }, offer) {
  commit('REMOVE_OFFER', offer);
}

export function resetOffers({ commit }) {
  commit('RESET_OFFERS');
}

export function postOrder({ state, commit }, anonymous = false) {
  const payload = state.order;
  if (anonymous) {
    delete payload.customer;
  }

  commit('SET_ORDER_LOADING', true);
  axios.post('qr/orders', payload).then((response) => {
    window.location.href = response.data.url;
    commit('SET_ORDER_LOADING', false);
  }).catch(({ response }) => {
    if (response.data.error === '3RD_PARTY_COMMUNICATION_FAILURE') {
      // eslint-disable-next-line no-alert
      alert('Er is iets fout gegaan, probeer het later nog eens. Excuses voor het ongemak.');
    }
    commit('SET_ORDER_LOADING', false);
  });
}
